import { Route, Routes as RoutesContainer } from 'react-router';
import GymList from '../Pages/GymList';
import Create from '../Pages/Create';

const PublicRoutes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/gym/list' element={<GymList />} />
      <Route exact path='/gym/create' element={<Create />} />
    </RoutesContainer>
  );
};
export default PublicRoutes;
